import { useStableCallback } from 'core/hooks/useStableCallback';

import { useSafeState } from './lifeCycle';

export default function usePromiseQuery<TArgs extends unknown[], TResult>(
  fn: (...args: TArgs) => Promise<TResult>
): readonly [(...args: TArgs) => Promise<TResult>, boolean] {
  const [isLoading, setIsLoading] = useSafeState(false);

  const query = useStableCallback((...args: TArgs): Promise<TResult> => {
    setIsLoading(true);
    return fn(...args).finally(() => setIsLoading(false));
  });

  return [query, isLoading] as const;
}
